import { Component, OnInit, Input } from '@angular/core';
import { CloudData, CloudOptions } from 'angular-tag-cloud-module';
@Component({
  selector: 'word-cloud-stats',
  templateUrl: './word-cloud.component.html',
  styleUrls: ['./word-cloud.component.css']
})
export class WordCloudComponent implements OnInit {
  @Input() data;
  options: CloudOptions = {
    // if width is between 0 and 1 it will be set to the width of the upper element multiplied by the value 
    width: 1,
    // if height is between 0 and 1 it will be set to the height of the upper element multiplied by the value 
    height: 1,
    overflow: false,
  };
  wcData: CloudData[];
  constructor() { }

  ngOnInit(): void {
    this.wcData = this.changeData(this.data.answers);
  }

  changeData(data): CloudData[] {
    let newData = data;
    for(let i = 0; i < newData.length; i++){
      newData[i].text = newData[i]['name'];
      newData[i].weight = newData[i]['value'];
      newData[i].tooltip = newData[i]['name'] + ': ' + newData[i]['value'];
      newData[i].color = '#7D17FF';
      delete newData[i].name;
      delete newData[i].value;
    }
    return newData;
  }

}
